import { AfterViewInit, Component, Input } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "angular-toastify";
import { isNil } from "lodash-es";
import { ApiService } from "src/app/api/api.service";
import { CoreService } from "src/app/services/core-service/core-service.service";
import { Result } from "src/app/shared/interfaces";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
    selector: 'formulario-nominar',
    templateUrl: './formulario-nominar.component.html',
    styleUrl: './formulario-nominar.component.scss'
})
export class FormularioNominarComponent {

    @Input() step: number = 1;
    @Input() formulario: FormGroup = {} as FormGroup<any>;
    @Input() sinPaginacion: boolean = false;
    @Input() periodos: any[] = [];
    @Input() administrador: boolean = false;
    private urlBase: string = '';
    public _image: string | any = '';
    private imagenUpload: File | any = null;
    private _departamentos: string[] = [
        "Guatemala",
        "Baja Verapaz",
        "Alta Verapaz",
        "El Progreso",
        "Izabal",
        "Zacapa",
        "Chiquimula",
        "Santa Rosa",
        "Jalapa",
        "Jutiapa",
        "Sacatepéquez",
        "Chimaltenango",
        "Escuintla",
        "Sololá",
        "Totonicapán",
        "Quetzaltenango",
        "Suchitepéquez",
        "Retalhuleu",
        "San Marcos",
        "Huehuetenango",
        "Quiché",
        "Baja Verapaz",
        "Petén"
    ];

    actualizarCategoria(): void {
        const catId = this.formulario.value.categoria_id;
        this.categorias.patchValue({
            social: catId === 1,
            deporte: catId === 2,
            ciencia: catId === 3,
            empresarial: catId === 4,
            arte: catId === 5,
            elegidoPorElPublico: catId === 6,
            orator: catId === 7,
        });
    }

    cargarImagenActual(): void {
        const imagFormulario = this.formulario.value.imagen;
        if (isNil(imagFormulario)) {
            return;
        }
        this._image = `${this.urlBase}/uploads/${imagFormulario}`
    }

    categorias = new FormGroup({
        social: new FormControl(false),
        deporte: new FormControl(false),
        ciencia: new FormControl(false),
        empresarial: new FormControl(false),
        arte: new FormControl(false),
        orator: new FormControl(false),
        elegidoPorElPublico: new FormControl(false)
    })

    constructor(
        private fb: FormBuilder,
        private core: CoreService,
        private ntf: ToastService,
        private api: ApiService
    ) {
        this.urlBase = environment.apiUrl;
    }

    actualizarCategorias(event: any) {
        const categoria = event.target.id;
        const categorias = this.categorias.value;
        switch (categoria) {
            case 'social':
                this.categorias.patchValue({
                    deporte: false,
                    ciencia: false,
                    empresarial: false,
                    arte: false,
                    orator: false,
                    elegidoPorElPublico: false
                })
                if (categorias.social) {
                    this.formulario.patchValue({ categoria_id: 1, categoria: { id: 1, nombre: 'Social', imagen: 'assets/img/icon/social.png' } })
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } })
                }
                break;
            case 'deporte':
                this.categorias.patchValue({
                    social: false,
                    ciencia: false,
                    empresarial: false,
                    arte: false,
                    orator: false,
                    elegidoPorElPublico: false
                })
                if (categorias.deporte) {
                    this.formulario.patchValue({ categoria_id: 2, categoria: { id: 2, nombre: 'Deporte', imagen: 'assets/img/icon/deporte.png' } })
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } })
                }
                break;
            case 'ciencia':
                this.categorias.patchValue({
                    deporte: false,
                    social: false,
                    empresarial: false,
                    arte: false,
                    orator: false,
                    elegidoPorElPublico: false
                })
                if (categorias.ciencia) {
                    this.formulario.patchValue({ categoria_id: 3, categoria: { id: 3, nombre: 'Ciencia', imagen: 'assets/img/icon/ciencia.png' } })
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } })
                }
                break;
            case 'empresarial':
                this.categorias.patchValue({
                    deporte: false,
                    ciencia: false,
                    social: false,
                    arte: false,
                    orator: false,
                    elegidoPorElPublico: false
                })
                if (categorias.empresarial) {
                    this.formulario.patchValue({ categoria_id: 4, categoria: { id: 4, nombre: 'Empresarial', imagen: 'assets/img/icon/empresarial.png' } })
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } })
                }
                break;
            case 'arte':
                this.categorias.patchValue({
                    deporte: false,
                    ciencia: false,
                    empresarial: false,
                    social: false,
                    orator: false,
                    elegidoPorElPublico: false
                })
                if (categorias.arte) {
                    this.formulario.patchValue({ categoria_id: 5, categoria: { id: 5, nombre: 'Arte', imagen: 'assets/img/icon/arte.png' } })
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } })
                }
                break;
            case 'elegidoPorElPublico':
                this.categorias.patchValue({
                    deporte: false,
                    ciencia: false,
                    empresarial: false,
                    social: false,
                    arte: false,
                    orator: false,
                });
                if (categorias.elegidoPorElPublico) {
                    this.formulario.patchValue({ categoria_id: 6, categoria: { id: 6, nombre: 'Elegido Por El Público', imagen: 'assets/img/icon/elegido.png' } });
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } });
                }
                break;
            case 'orator':
                this.categorias.patchValue({
                    deporte: false,
                    ciencia: false,
                    empresarial: false,
                    social: false,
                    arte: false,
                    elegidoPorElPublico: false,
                });
                if (categorias.orator) {
                    this.formulario.patchValue({ categoria_id: 7, categoria: { id: 7, nombre: 'Orator', imagen: 'assets/img/icon/orator.png' } })
                } else {
                    this.formulario.patchValue({ categoria_id: null, categoria: { id: null, nombre: null } })
                }
                break;
        }
    }

    agregarItems() {
        const nuevoLogro = this.fb.group({
            id: new FormControl(null),
            perfilId: new FormControl(null),
            logro: new FormControl('', Validators.required),
            holder: new FormControl('Ejemplo: Premio en')
        })

        this.logrosFormulario.push(nuevoLogro)
    }

    async cambioImagen(event: any) {
        if (event.target.files && event.target.files[0]) {
            this.imagenUpload = event.target.files[0] || null;

            if (this.imagenUpload.size > 1 * 1024 * 1024) { // 1 MB en bytes
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "La imagen debe ser menor a 1 MB.",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.imagenUpload = null;
                this._image = null;
                this.formulario.patchValue({ imagen: null });
                event.target.value = ''; // Resetea el input de archivo
                return;
            }

            const reader = new FileReader();
            reader.onload = e => this._image = reader.result;

            reader.readAsDataURL(this.imagenUpload);
            this.formulario.patchValue({ imagen: this.imagenUpload });
        }
    }

    async uploadImage(): Promise<boolean> {
        let success = true;
        try {
            this.core.lock()
            const file: File = this.imagenUpload;
            if (!isNil(file)) {
                const formData = new FormData();
                formData.append("file", file);

                const path = 'files/upload'
                const result = (await this.api.consulta(path, false, [], formData, 'POST', true)).data as Result
                this.formulario.patchValue({ imagen: result.data.file })
            }
        } catch (e) {
            this.ntf.error(`Error: ${e}`);
            success = false;
        } finally {
            this.core.unlock();
            return success;
        }
    }

    get mostrarAgregar(): boolean {
        return this.logrosFormulario.length < 5;
    }

    get departamentos(): string[] {
        return this._departamentos;
    }

    get logrosFormulario(): FormArray {
        return this.formulario.get('LogrosPerfil') as FormArray;
    }

    get redesSocialFormulario(): FormArray {
        return this.formulario.get('RedSocialPerfil') as FormArray
    }

    get imagenPreview(): string {
        return this._image;
    }
}